<template>
    <div style="width: 100%;">
         <flat-pickr
            v-model="value"
            :config="schema.dateConfig"
            :placeholder="schema.placeholder"
        />
    </div>
</template>
<script>
import { abstractField } from "vue-form-generator";
export default {
    mixins: [ abstractField ],

}
</script>